var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMsg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_4601)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0C27.9415 0 36 8.05852 36 18C36 27.9415 27.9415 36 18 36C8.05852 36 0 27.9415 0 18C0 8.05852 8.05852 0 18 0Z",
    fill: "#F7B733"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 10.25H10.5C9.46625 10.25 8.625 11.0912 8.625 12.125V22.125C8.625 23.1587 9.46625 24 10.5 24H12.375V27.125C12.375 27.3656 12.5131 27.5837 12.7288 27.6881C12.8156 27.7294 12.9081 27.75 13 27.75C13.1394 27.75 13.2775 27.7038 13.3906 27.6131L17.9069 24H25.5C26.5338 24 27.375 23.1587 27.375 22.125V12.125C27.375 11.0912 26.5338 10.25 25.5 10.25ZM18 19H13C12.6544 19 12.375 18.72 12.375 18.375C12.375 18.03 12.6544 17.75 13 17.75H18C18.3456 17.75 18.625 18.03 18.625 18.375C18.625 18.72 18.3456 19 18 19ZM23 16.5H13C12.6544 16.5 12.375 16.22 12.375 15.875C12.375 15.53 12.6544 15.25 13 15.25H23C23.3456 15.25 23.625 15.53 23.625 15.875C23.625 16.22 23.3456 16.5 23 16.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4601"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsg);
export default __webpack_public_path__ + "static/media/MSG.de2d3ac0fb4ba49b7968d8425309eb8d.svg";
export { ForwardRef as ReactComponent };